import {
  ProductType,
  ProductTypeUrlSuffix,
  ProductTypeUrlSuffixIndex,
  ProductTypeUrlSuffixPlural,
  ProductTypeUrlSuffixPluralIndex,
} from '../../common';

export const getProductTypeUrlSuffix = (
  productType: ProductType = ProductType.Family,
  isPlural = false
): ProductTypeUrlSuffixPluralIndex | ProductTypeUrlSuffixIndex => {
  const suffixMapping = isPlural ? ProductTypeUrlSuffixPlural : ProductTypeUrlSuffix;

  return suffixMapping[productType];
};
